<template>
  <div v-loading.fullscreen.lock="fullscreenLoading" style="text-align:right">
    <a class="muban" href="https://file.qizhangfang.net/data/down/invoiceExcel/托管税盘导入模板.xlsx" >通用模板下载</a>
    <upload-excel-component :rawFile='rawFile' :on-success="handleSuccess" :before-upload="beforeUpload" />
  </div>
</template>

<script>
import UploadExcelComponent from "@/components/import/son/index.vue";
import { addCompany } from "@/api/ea";
export default {
  components: { UploadExcelComponent },
    props: {
    rawFile: ""
  },
  
  data() {
    return {
      fullscreenLoading:false
    };
  },
  methods: {
    beforeUpload(file) {
      if(!file){
        this.$message({
          message: "请选择文件",
          type: "warning"
        });
        return false;
      }
      const isLt1M = file.size / 1024 / 1024 < 1;
      if (isLt1M) {
        return true;
      }
      this.$message({
        message: "请不要上传大于1M的文件。",
        type: "warning"
      });
      return false;
    },
    handleSuccess({ results, header }) {
      console.log(results)
      console.log(header)
      this.fullscreenLoading = true
      let items = [];
      results.map(item => {
        console.log(item);
        item.map(v=>{
          let obj = {};
          obj.name = v["*公司名"]
          obj.tax_no = v["*纳税人识别号"]
          obj.type = v["*公司类型"] == "小规模纳税人"?1:2
          obj.userName = v["*用户名"]
          // obj.password = v["*密码"]
          items.push(obj);
        })
      });
      console.log(items)
      addCompany(items).then(res=>{
        if(res.data.msg == "success"){
          this.$qzfMessage("导入成功", 3)
          this.fullscreenLoading = false
          this.$emit("success")
        }
      })
    }
  }
};
</script>


<style lang="scss" scoped>
.muban {
  text-align: left;
  font-size: 14px;
  color: red;
  display: block;
  width: 150px;
}
</style>
